import React from 'react'
import BrandPanel from './BrandPanel'
import FormPanel from './FormPanel'
import SignUpForm from './SignUpForm'
import SignInForm from './SignInForm'
import ForgotPasswordForm from './ForgotPasswordForm'
import CreateNewPasswordForm from './CreateNewPasswordForm'

import {
  Screen,
} from '@SiteModules/Authentication/types'

import './AuthLayout.scss'

interface AuthLayoutProps {
  readonly initialScreen?: Screen
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ initialScreen }) => {
  const screen: Screen = initialScreen || 'signup'

  return (
    <div className="AuthLayout">
      <BrandPanel />
      <FormPanel>
        {screen === 'signup' && <SignUpForm />}
        {screen === 'signin' && <SignInForm />}
        {screen === 'forgot' && <ForgotPasswordForm />}
        {screen === 'password' && <CreateNewPasswordForm />}
      </FormPanel>
    </div>
  )
}

export default AuthLayout
